// Centralized analytics: Meta Pixel, TikTok Pixel, GA4.
// Pixels are PREPARED but only fire when (a) an ID is configured via env and
// (b) the user has given cookie consent. All calls are safe no-ops otherwise.

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || "";
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

const CONSENT_KEY = "dcl_cookie_consent";

let initialized = false;

export function getConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch (e) { return null; }
}
export function setConsent(value) {
  try { localStorage.setItem(CONSENT_KEY, value); } catch (e) {}
  if (value === "accepted") initPixels();
}
export function hasConsent() {
  return getConsent() === "accepted";
}

function loadMeta() {
  if (!META_PIXEL_ID || window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", META_PIXEL_ID); window.fbq("track", "PageView");
  /* eslint-enable */
}

function loadTikTok() {
  if (!TIKTOK_PIXEL_ID || window.ttq) return;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.load = function (e) { var n = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = n; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); var o = d.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = n + "?sdkid=" + e + "&lib=" + t; var a = d.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a); };
    ttq.load(TIKTOK_PIXEL_ID); ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

function loadGA() {
  if (!GA_ID || window.gtag) return;
  var s = document.createElement("script"); s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date()); window.gtag("config", GA_ID);
}

export function initPixels() {
  if (initialized || !hasConsent()) return;
  loadMeta(); loadTikTok(); loadGA();
  initialized = true;
}

const EVENT_MAP = {
  page_view: { meta: "PageView", tiktok: "Browse", ga: "page_view" },
  view_content: { meta: "ViewContent", tiktok: "ViewContent", ga: "view_content" },
  lead: { meta: "Lead", tiktok: "CompleteRegistration", ga: "generate_lead" },
  purchase: { meta: "Purchase", tiktok: "Subscribe", ga: "purchase" },
};

export function trackEvent(name, params = {}) {
  if (!hasConsent()) return;
  const m = EVENT_MAP[name] || {};
  try {
    if (window.fbq && m.meta) window.fbq("track", m.meta, params);
    if (window.ttq && m.tiktok) window.ttq.track(m.tiktok, params);
    if (window.gtag && m.ga) window.gtag("event", m.ga, params);
  } catch (e) {}
}
